<template>
  <el-form
    ref="feesForWeightAndNoiseForm"
    :model="model"
    :rules="rules"
    label-width="11.5em"
    label-position="left"
    class="fees-for-weight-and-noise-form"
  >
    <div class="el-form--inline">
    <BillingYm v-model="billingYm" :required="true" :searchCond="searchMode" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" />
    <BillToCode v-model="billToCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editDisabledMode && editMode" :autocomplete-list="autocompleteCustomerCodeSet" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <RouteCode v-model="routeCode" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode && editMode" :initialize="true" />
      <Callsign v-model="callsign" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode && editMode"/>
    </div>
    <div class="el-form--inline">
      <AirportCode v-model="departureAirportCode" label="出発地" prop="departure_airport_code"
        :required="!searchMode" :searchCond="searchMode" :autocomplete-list="autocompleteAirportCodeSet" :disabled="editDisabledMode && editMode" :initialize="true" />
      <AirportCode v-model="destinationAirportCode" label="目的地" prop="destination_airport_code"
        :required="!searchMode" :searchCond="searchMode" :disabled="true" />
    </div>
    <div class="el-form--inline">
      <FlightPurposeCode v-model="flightPurposeCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editDisabledMode && editMode" :initialize="true" />
      <!-- <Count v-model="landingCount" label="着陸回数" prop="landing_count"
        :required="!searchMode" :searchCond="searchMode" /> -->
      <template v-if='formMode === "search"'>
        <Numeric v-model="landingCount" label="着陸回数" prop="landing_count"
            :required="!searchMode" :searchCond="searchMode" :min="0" :max="99" :step="1" :disabled="editDisabledMode && editMode" />
      </template>
      <template v-else>
        <Numeric v-model="landingCount" label="着陸回数" prop="landing_count"
            :required="!searchMode" :searchCond="searchMode" placeholder="0～99" :min="0" :max="99" :step="1" :disabled="editDisabledMode && editMode" />
      </template>
    </div>
    <template v-if='formMode === "search"'>
      <DateTimeRange :dateTimeFrom.sync="startDateTime" :dateTimeTo.sync="endDateTime" label="着陸日時"
        :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
    </template>
    <template v-else>
      <div class="el-form--inline">
        <DateTime v-model="landingTime" label="着陸日時" prop="landing_time"
          :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
        <!-- <Blank /> -->
        <template v-if="editDisabledMode && !searchMode">
          <BillingExclusion v-model="billingExclusion" label="請求除外" prop="billing_exclusion_flag" :initialize="true"
            placeholder="請求除外時のみ選択" :clearable="true" :disabled="editMode"  codeId="BILLING_EXCLUSION_ARR"/>
        </template>
        <template v-else>
          <Blank />
        </template>
      </div>
    </template>
    <el-divider />
      <RegistrationSymbol v-model="registrationSymbol" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autocomplete-list="autocompleteRegistrationSymbolSet" />
    <template v-if='formMode === "search" || formMode === "edit" '>
      <div class="el-form--inline">
        <ModelCode v-model="modelCode" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :initialize="true"
          :autocomplete-list="autocompleteModelCodeSet" />
        <AircraftType v-model="aircraftType" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :initialize="true" />
      </div>
      <template v-if='formMode === "search"'>
        <div class="el-form--inline">
          <Numeric v-model="weight" label="重量[t]" prop="weight" :required="!searchMode" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1" :disabled="editDisabledMode && editMode"/>
          <Numeric v-model="noiseLevel" label="騒音値[EPNdB]" prop="noise_level" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999" :step="1" :disabled="editDisabledMode && editMode"/>
        </div>
      </template>
      <template v-else>
        <div class="el-form--inline">
          <Numeric v-model="weight" label="重量[t]" prop="weight" placeholder="0.1～999.9" :required="!searchMode" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1" :disabled="editDisabledMode && editMode"/>
          <Numeric v-model="noiseLevel" label="騒音値[EPNdB]" prop="noise_level" placeholder="0～999" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999" :step="1" :disabled="editDisabledMode && editMode"/>
        </div>
      </template>
    </template>
    <el-divider />
    <div class="el-form--inline">
      <Taxation v-model="taxation" :required="!searchMode" :searchCond="searchMode" :initialize="true" :disabled="editDisabledMode && editMode" />
      <template v-if='formMode === "search"'>
        <Numeric v-model="tax" label="税率[%]" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
      </template>
      <template v-else-if='formMode === "edit"'>
        <Numeric v-model="tax" label="税率[%]" placeholder="0～99" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
      </template>
      <template v-else>
        <Blank />
      </template>
    </div>
    <div class="el-form--inline">
      <ExemptionCode v-model="exemptionCode" :required="!searchMode" :initialize="true" :searchCond="searchMode" :disabled="editDisabledMode && editMode"/>
      <ExemptionRate v-model="exemptionRate" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode && editMode"/>
    </div>
    <div class="el-form--inline">
      <Numeric v-model="unitFee" label="単位料金[円]" prop="unit_fee"
        :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="landingFeeBeforeExemption" label="着陸料(減免前)[円]" prop="landing_fee_before_exemption"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="landingFeeWithoutTax" label="着陸料(税抜)[円]" prop="landing_fee_without_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="landingFeeTax" label="着陸料(税)[円]" prop="landing_fee_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="landingFeeWithTax" label="着陸料(税込)[円]" prop="landing_fee_with_tax"
        :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      <template v-if='formMode === "search"'>
        <div class="parent_Box">
          <div class="child_Box">
            <el-checkbox v-model="manualDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に補正登録データのみ表示する</el-checkbox>
          </div>
          <div class="child_Box">
            <el-checkbox v-model="automaticDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に自動入力データのみ表示する</el-checkbox>
          </div>
        </div>
      </template>
    </div>
    <!-- <template v-if='formMode === "search"'> -->
      <!-- <div class="checkBox"> -->
        <!-- <el-checkbox-group v-model="registType" :min="0" :max="1"> -->
          <!-- <el-checkbox v-model="manualDataOnly" v-if="searchMode" :label="あ" :key="あ" :disabled="editDisabledMode">あ</el-checkbox>
          <el-checkbox v-model="automaticDataOnly" v-if="searchMode" :label="い" :key="い" :disabled="editDisabledMode" >い</el-checkbox> -->
          <!-- <el-checkbox v-for="regist_type_name in registTypes" :label="regist_type_name" :key="regist_type_name">{{regist_type_name}}</el-checkbox> -->
        <!-- </el-checkbox-group> -->
      <!-- </div> -->
    <!-- </template> -->
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import DateTimeRange from '@/components/molecules/form/date/DateTimeRange.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import Callsign from '@/components/molecules/form/text/Callsign.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import ModelCode from '@/components/molecules/form/autocomplete/ModelCode.vue'
// import Fee from '@/components/molecules/form/text/Fee.vue'
// import Tax from '@/components/molecules/form/number/Tax.vue'
import Taxation from '@/components/molecules/form/select/Taxation.vue'
import FlightPurposeCode from '@/components/molecules/form/select/FlightPurposeCode.vue'
import AircraftType from '@/components/molecules/form/select/AircraftType.vue'
// import Weight from '@/components/molecules/form/number/Weight.vue'
// import NoiseLevel from '@/components/molecules/form/number/NoiseLevel.vue'
// import Count from '@/components/molecules/form/number/Count.vue'
import ExemptionCode from '@/components/molecules/form/select/ExemptionCode.vue'
import ExemptionRate from '@/components/molecules/form/text/ExemptionRate.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
// import OwnAirport from '@/mixins/OwnAirport.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
import BillingExclusion from '@/components/molecules/form/select/BillingExclusion.vue'

export default {
  components: {
    BillingYm,
    RegistrationSymbol,
    DateTimeRange,
    DateTime,
    BillToCode,
    RouteCode,
    Callsign,
    AirportCode,
    ModelCode,
    // Fee,
    // Tax,
    Taxation,
    FlightPurposeCode,
    AircraftType,
    // Weight,
    // NoiseLevel,
    // Count,
    ExemptionCode,
    ExemptionRate,
    Numeric,
    Blank,
    BillingExclusion
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    registrationSymbol: {
      get () {
        return this.model.registration_symbol
      },
      set (registrationSymbol) {
        const form = { ...this.model }
        form.registration_symbol = registrationSymbol
        this.$emit('input', form)
      }
    },
    startDateTime: {
      get () {
        return this.model.start_date_time
      },
      set (startDateTime) {
        const form = { ...this.model }
        form.start_date_time = startDateTime
        this.$emit('input', form)
      }
    },
    endDateTime: {
      get () {
        return this.model.end_date_time
      },
      set (endDateTime) {
        const form = { ...this.model }
        form.end_date_time = endDateTime
        this.$emit('input', form)
      }
    },
    landingTime: {
      get () {
        return this.model.landing_time
      },
      set (landingTime) {
        const form = { ...this.model }
        form.landing_time = landingTime
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    callsign: {
      get () {
        return this.model.callsign
      },
      set (callsign) {
        const form = { ...this.model }
        form.callsign = callsign
        this.$emit('input', form)
      }
    },
    departureAirportCode: {
      get () {
        return this.model.departure_airport_code
      },
      set (departureAirportCode) {
        const form = { ...this.model }
        form.departure_airport_code = departureAirportCode
        this.$emit('input', form)
      }
    },
    destinationAirportCode: {
      get () {
        return this.getDefaultOwnAirport()
      }
    },
    flightPurposeCode: {
      get () {
        return this.model.flight_purpose_code
      },
      set (flightPurposeCode) {
        const form = { ...this.model }
        form.flight_purpose_code = flightPurposeCode
        this.$emit('input', form)
      }
    },
    modelCode: {
      get () {
        return this.model.model_code
      },
      set (modelCode) {
        const form = { ...this.model }
        form.model_code = modelCode
        this.$emit('input', form)
      }
    },
    landingFeeWithoutTax: {
      get () {
        return this.model.landing_fee_without_tax
      },
      set (landingFeeWithoutTax) {
        const form = { ...this.model }
        form.landing_fee_without_tax = landingFeeWithoutTax
        this.$emit('input', form)
      }
    },
    landingFeeTax: {
      get () {
        return this.model.landing_fee_tax
      },
      set (landingFeeTax) {
        const form = { ...this.model }
        form.landing_fee_tax = landingFeeTax
        this.$emit('input', form)
      }
    },
    landingFeeWithTax: {
      get () {
        return this.model.landing_fee_with_tax
      },
      set (landingFeeWithTax) {
        const form = { ...this.model }
        form.landing_fee_with_tax = landingFeeWithTax
        this.$emit('input', form)
      }
    },
    tax: {
      get () {
        return this.model.tax
      },
      set (tax) {
        const form = { ...this.model }
        form.tax = tax
        this.$emit('input', form)
      }
    },
    taxation: {
      get () {
        return this.model.taxation
      },
      set (taxation) {
        const form = { ...this.model }
        form.taxation = taxation
        this.$emit('input', form)
      }
    },
    aircraftType: {
      get () {
        return this.model.aircraft_type
      },
      set (aircraftType) {
        const form = { ...this.model }
        form.aircraft_type = aircraftType
        this.$emit('input', form)
      }
    },
    weight: {
      get () {
        return this.model.weight
      },
      set (weight) {
        const form = { ...this.model }
        form.weight = weight
        this.$emit('input', form)
      }
    },
    noiseLevel: {
      get () {
        return this.model.noise_level
      },
      set (noiseLevel) {
        const form = { ...this.model }
        form.noise_level = noiseLevel
        this.$emit('input', form)
      }
    },
    landingCount: {
      get () {
        return this.model.landing_count
      },
      set (landingCount) {
        const form = { ...this.model }
        form.landing_count = landingCount
        this.$emit('input', form)
      }
    },
    exemptionCode: {
      get () {
        return this.model.exemption_code
      },
      set (exemptionCode) {
        const form = { ...this.model }
        form.exemption_code = exemptionCode
        this.$emit('input', form)
      }
    },
    exemptionRate: {
      get () {
        return this.model.exemption_rate
      },
      set (exemptionRate) {
        const form = { ...this.model }
        form.exemption_rate = exemptionRate
        this.$emit('input', form)
      }
    },
    unitFee: {
      get () {
        return this.model.unit_fee
      },
      set (unitFee) {
        const form = { ...this.model }
        form.unit_fee = unitFee
        this.$emit('input', form)
      }
    },
    landingFeeBeforeExemption: {
      get () {
        return this.model.landing_fee_before_exemption
      },
      set (landingFeeBeforeExemption) {
        const form = { ...this.model }
        form.landing_fee_before_exemption = landingFeeBeforeExemption
        this.$emit('input', form)
      }
    },
    manualDataOnly: {
      get () {
        return this.model.manual_data_only
      },
      set (manualDataOnly) {
        const form = { ...this.model }
        form.manual_data_only = manualDataOnly
        this.$emit('input', form)
        if (manualDataOnly === true) {
          form.automatic_data_only = false
        }
      }
    },
    automaticDataOnly: {
      get () {
        return this.model.automatic_data_only
      },
      set (automaticDataOnly) {
        const form = { ...this.model }
        form.automatic_data_only = automaticDataOnly
        this.$emit('input', form)
        if (automaticDataOnly === true) {
          form.manual_data_only = false
        }
      }
    },
    // registType: {
    //   get () {
    //     return this.model.regist_type
    //   },
    //   set (registType) {
    //     const form = { ...this.model }
    //     form.regist_type = registType
    //     this.$emit('input', form)
    //   }
    // },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    },
    billingExclusion: {
      get () {
        return this.model.billing_exclusion_flag
      },
      set (billingExclusion) {
        const form = { ...this.model }
        if (billingExclusion === '') { billingExclusion = undefined }
        form.billing_exclusion_flag = billingExclusion
        this.$emit('input', form)
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.feesForWeightAndNoiseForm.resetFields()
      this.billingYm = this.getDefaultBillingYm()
      if (this.searchMode) {
        this.model.start_date_time = null
        this.model.end_date_time = null
        this.model.manual_data_only = false
        this.model.automatic_data_only = false
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForWeightAndNoiseForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.fees-for-weight-and-noise-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
    // margin-left: 10px;
  }
  .el-form-item.date-time-range{
    .el-input__inner{
      width: 47em;
    }
  }
  .el-form-item.date-time{
    .el-input__inner{
      padding-right: 14px
    }
  }
  .parent_Box{
    padding-right: 15px
  }
}
</style>
